const IPAddress = "http://localhost:9002/";
export const apiService = {
  login: IPAddress + "users/login",
};
